module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "first",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tDiversion Books"), _c('br'), _vm._v("\n\tA Division of Diversion Publishing Corp."), _c('br'), _vm._v("\n\t443 Park Avenue South, Suite 1008"), _c('br'), _vm._v("\n\tNew York, NY 10016"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.DiversionBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tCopyright © 1980 by Becky Lee Weyrich"), _c('br'), _vm._v("\n\tAll rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tThis is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tFor more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tFirst Diversion Books edition June 2014"), _c('br'), _vm._v("\n\tISBN: "), _c('span', {
    staticStyle: {
      "font-family": "'Liberation Serif', serif",
      "font-size": "1em",
      "line-height": "1.375",
      "text-align": "justify"
    }
  }, [_vm._v("978-1-62681-336-6")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("\n\tAlso by Becky Lee Weyrich")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap262649",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swan’s Way"), _c('br'), _vm._v("\n\tSavannah Scarlett"), _c('br'), _vm._v("\n\tRainbow Hammock"), _c('br'), _vm._v("\n\tCaptive of Desire"), _c('br'), _vm._v("\n\tSands of Destiny"), _c('br'), _vm._v("\n\tThe Scarlet Thread"), _c('br'), _vm._v("\n\tOnce Upon Forever"), _c('br'), _vm._v("\n\tSummer Lightning"), _c('br'), _vm._v("\n\tSilver Tears"), _c('br'), _vm._v("\n\tTainted Lilies"), _c('br'), _vm._v("\n\tAlmost Heaven"), _c('br'), _vm._v("\n\tWhispers in Time"), _c('br'), _vm._v("\n\tSweet Forever"), _c('br'), _vm._v("\n\tRapture’s Slave"), _c('br'), _vm._v("\n\tGypsy Moon"), _c('br'), _vm._v("\n\tHot Winds from Bombay"), _c('br'), _vm._v("\n\tThe Thistle and the Rose"), _c('br'), _vm._v("\n\tForever, For Love")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("For Hank"), _c('br'), _vm._v("\n\tWith Love")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f43ac55","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02_xxxxxxxxxxxxx_Copyright.vue
// module id = 63
// module chunks = 0